import { capitalize } from '@peloton/text/titleize';
import { toAnalyticsBrowseCategoryProp } from '@engage/browse-categories/analytics';
import type { BrowseCategorySlug } from '@engage/browse-categories/models';
import type { FilterAnalyticsProps } from '@engage/filters/selectors';
import { classLanguageSettingsToAnalyticsList } from '@engage/settings/analytics';
import type { ClassLanguage } from '@engage/settings/models';

export enum EmptyLibrarySource {
  Library = 'Classes',
  Schedule = 'Schedule',
}

export enum EmptyStateType {
  NoClasses = 'No Classes',
  LanguageSettings = 'Language Settings',
}

export enum LibraryEventNames {
  ViewedOnDemandLibrary = 'Viewed On-Demand Library',
  ViewedEmptyLibrary = 'Viewed Empty Library State',
  FilteredOnDemandLibrary = 'Filtered On-Demand Library',
  SortedOnDemandLibrary = 'Sorted On-Demand Library',
  ClearedFilters = 'Cleared Filters',
}

export enum ViewedLibrarySource {
  TopNav = 'Top Nav',
  Home = 'Home',
  QuickFilters = 'Quick Filters',
}

export const trackViewedLibraryPage = (
  slug: BrowseCategorySlug,
  classLanguageSettings: ClassLanguage[],
  source: ViewedLibrarySource,
) => ({
  event: LibraryEventNames.ViewedOnDemandLibrary,
  classLanguageSettings: classLanguageSettingsToAnalyticsList(classLanguageSettings),
  ...toAnalyticsBrowseCategoryProp(slug),
  source,
});

export const trackViewedEmptyLibraryPage = (
  source: EmptyLibrarySource,
  emptyStateType: EmptyStateType,
  classLanguageSettings: ClassLanguage[],
  explicitBlocked: boolean,
  browseProps: FilterAnalyticsProps,
) => ({
  event: LibraryEventNames.ViewedEmptyLibrary,
  source,
  emptyStateType,
  classLanguageSettings: classLanguageSettingsToAnalyticsList(classLanguageSettings),
  '[Explicit Setting]': capitalize(explicitBlocked.toString()),
  ...browseProps,
});

export const trackFilteredLibrary = (
  props: FilterAnalyticsProps,
  classLanguageSettings: ClassLanguage[],
) => ({
  event: LibraryEventNames.FilteredOnDemandLibrary,
  classLanguageSettings: classLanguageSettingsToAnalyticsList(classLanguageSettings),
  ...props,
});

export const trackSortedLibrary = (sortValue: string) => ({
  event: LibraryEventNames.SortedOnDemandLibrary,
  sortValue,
});

export const trackClearedFilters = (props: FilterAnalyticsProps, source: string) => ({
  event: LibraryEventNames.ClearedFilters,
  source,
  ...props,
});

export type { SearchSharedProperties } from './analyticsTypes';
